import React from 'react';
import AuthProvider from "./AuthProvider";
import {HashRouter} from "react-router-dom";
import AppRoutesWrapper from "./AppRoutesWrapper";
import AxiosInitialConfigurer from "./AxiosInitialConfigurer";
import {ThemeProvider} from "@mui/material";
import Theme from "src/Theme";
import {LocalizationProvider} from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import nl from 'date-fns/locale/nl';
import {ConfirmProvider} from "material-ui-confirm";
import {setDefaultOptions} from "date-fns";

const App = () => {
  setDefaultOptions({
    locale: nl
  });

  return (
    <ThemeProvider theme={Theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nl}>
        <ConfirmProvider>
          <HashRouter>
            <AuthProvider>
              <AxiosInitialConfigurer>
                <AppRoutesWrapper />
              </AxiosInitialConfigurer>
            </AuthProvider>
          </HashRouter>
        </ConfirmProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;

App.propTypes = {}

App.defaultProps = {}